<template>
	<div class="content">
		<h3>创建任务单</h3>
		<div class="item">
			<el-form ref="form" inline  :model="form" label-width="100px">
                <el-form-item label="任务单号" style="width:100%">
					<el-input v-model="form.factoryName" style="width:800px"></el-input>
				</el-form-item>
                <el-form-item label="任务单类型" style="width:100%">
					<el-select v-model="form.outstate" placeholder="请选择" style="width:800px">
                        <el-option v-for="item in outstock" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary" @click="SelFactory">查 询</el-button>
				<el-button type="primary" @click="SelFactory">创建任务单</el-button>
			</div>
            <div class="item">
                <el-table :data="tableData" border>
                    <el-table-column align="center" prop="Address" label="任务单号"></el-table-column>
                    <el-table-column align="center" prop="Address" label="任务名称"></el-table-column>
                    <el-table-column align="center" prop="Address" label="任务类型"></el-table-column>
                    <el-table-column align="center" prop="Address" label="车间编号"></el-table-column>
                    <el-table-column align="center" prop="Address" label="车间名称"></el-table-column>
                    <el-table-column align="center" prop="Address" label="产线编号"></el-table-column>
                    <el-table-column align="center" prop="Address" label="产线名称"></el-table-column>
                    <el-table-column align="center" prop="Address" label="制单日期"></el-table-column>
                    <el-table-column align="center" prop="Address" label="制单人"></el-table-column>
                    <el-table-column align="center" prop="Address" label="审核状态"></el-table-column>
                    <el-table-column align="center" prop="Address" label="下载状态"></el-table-column>
                    <el-table-column align="center" prop="Address" label="操作"></el-table-column>
                    <el-table-column align="center" prop="Address" label="修改"></el-table-column>
                    <el-table-column align="center" prop="Address" label="删除"></el-table-column>
                </el-table>
                <el-pagination
                background
                @current-change="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :total="pageNum"
                :page-size="10">
                </el-pagination>
            </div>
		</div>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			tableData: [],
			form:{

            },
			rules: {
        		factoryName:[
          			{ required: true, message: '请输入一个工厂名称', trigger: 'change' }
        		],
			},
			pageNum:0,
		}
	},
	methods: {
		close(){
			this.$refs['form'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
        },
        handleCurrentChange(){

        }
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 100px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/CreateTaskBillList.vue